require('./helpers/bundle-manifest').register(JSON.parse("{\"1bp4t\":\"index.8c524cef.js\",\"5r1eP\":\"Logo.4f927071.png\",\"lxemD\":\"index.21a53bc1.css\"}"));